import { MockService } from '../mockService';
import type { AuthenticationRepositoryInterface } from '@/api/interfaces/authentication/authenticationRepository';
import { staticImplements } from '@/decorators/staticImplements';
import { ServiceSuccess } from '@/api/interfaces/serviceSuccess';
import { DeaAdditionalUserData } from '@/api/interfaces/authentication/deaAdditionalUserData';

@staticImplements<AuthenticationRepositoryInterface>()
export class AuthenticationRepository {
    static logoutToken(): Promise<ServiceSuccess> {
        const mockService = new MockService<ServiceSuccess>();

        // trigger fail
        // return mockService.runServiceWithFailure(5);

        // trigger success
        return mockService.runServiceWithSuccess({ message: 'OK' }, 5);
    }

    static getAdditionalUserData(): Promise<DeaAdditionalUserData> {
        const mockService = new MockService<DeaAdditionalUserData>();
        return mockService.runServiceWithSuccess(
            { isInstaller: false, installers: [] },
            5,
        );
    }
}
